/**
 * @description Supported application regions
 */
export type AppRegion = 'au' | 'eu' | 'us'

export interface RegionOption {
  value: AppRegion
  label: string
}

export const APP_REGIONS: RegionOption[] = [
  { value: 'au', label: 'Asia Pacific' },
  { value: 'eu', label: 'Europe' },
  { value: 'us', label: 'North America' },
]

/**
 * URL code alias mapping
 * This is only used if a customer has requested we provide an alias URL
 * Currently only one customer has asked for this
 */
export const REGION_ALIASES: Record<string, Record<string, string>> = {
  au: {
    'coles': 'XTW7ZVC8TU1W',
    'coles-sit': 'XAORDBQ9WHJG',
  },
}

/**
 * Checks if the provided value is a valid region
 */
export function isValidRegion(value: string): value is AppRegion {
  return value === 'au' || value === 'eu' || value === 'us'
}
